import { createPrimitiveAtom } from '@reatom/core/primitives'

export const poNumberLoadingAtom = createPrimitiveAtom(false)
